module.exports = __webpack_public_path__ + "img/4.2fc7d847.jpg";